module.exports = __webpack_public_path__ + "static/logo-buzzfeed-b443e5bdad9b7b9f322ea4473a3137d0.jpg";